// extracted by mini-css-extract-plugin
export default {"container":"shipments_container__56Ggr","spin":"shipments_spin__kP8r9","header":"shipments_header__8NtDi","title":"shipments_title__Xy+tc","content":"shipments_content__O2mxJ"};